import { OwnerPayAppsList } from "@/components/pay-apps/OwnerPayAppsList";
import { SubPayAppsList } from "@/components/pay-apps/SubPayAppsList";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface PayApplicationsTabProps {
  projectId: string;
}

export function PayApplicationsTab({ projectId }: PayApplicationsTabProps) {
  return (
    <Tabs defaultValue="subcontractor" className="space-y-4">
      <TabsList>
        <TabsTrigger value="subcontractor">Subcontractor</TabsTrigger>
        <TabsTrigger value="owner">Owner</TabsTrigger>
      </TabsList>
      <TabsContent value="subcontractor">
        <SubPayAppsList projectId={projectId} title="" />
      </TabsContent>
      <TabsContent value="owner">
        <OwnerPayAppsList projectId={projectId} title="" />
      </TabsContent>
    </Tabs>
  );
}
